import React from 'react'
import { string, number, bool } from 'prop-types'
import classNames from 'classnames'

import DiscountBadge from 'views/components/atoms/DiscountBadge'
import Image from 'views/components/atoms/Image'

import './ImageWithDiscountBadge.scss'

const ImageWithDiscountBadge = ({
  imageUrl,
  alt,
  discountPercent,
  thumbnail,
  lazyLoad,
  tighterThumbnailWithDarkBackground,
  ...rest
}) => {
  const badgeLabel = discountPercent ? (
    <span>
      - <strong>{discountPercent}</strong>%
    </span>
  ) : null

  const imageClassNameFinal = classNames('a-fullwidth-image', {
    'a-thumbnail-image': thumbnail
  })

  const imageProps = {
    src: imageUrl,
    alt,
    className: imageClassNameFinal,
    ...rest
  }

  if (lazyLoad) {
    // @ts-ignore
    imageProps.lazyLoad = true
  }

  const imageWrapperClassNameString = classNames('m-ImageWithDiscountBadge', {
    'm-ImageWithDiscountBadge--tighterThumbnailWithDarkBackground':
      thumbnail && tighterThumbnailWithDarkBackground
  })

  return (
    <div className={imageWrapperClassNameString}>
      <Image {...imageProps} />
      {badgeLabel && (
        <div className="m-ImageWithDiscountBadge__badge">
          <DiscountBadge discount={discountPercent}>{badgeLabel}</DiscountBadge>
        </div>
      )}
    </div>
  )
}

ImageWithDiscountBadge.propTypes = {
  imageUrl: string.isRequired,
  alt: string.isRequired,
  discountPercent: number,
  thumbnail: bool,
  lazyLoad: bool,
  tighterThumbnailWithDarkBackground: bool
}

ImageWithDiscountBadge.defaultProps = {
  discountPercent: null,
  thumbnail: false,
  lazyLoad: false,
  tighterThumbnailWithDarkBackground: false
}

export default ImageWithDiscountBadge
